<template>
    <div id="PartnerIndex" class="index" v-if="!isFirstLoading">
        <BannerKV 
        :banners="bannerImages"
        :isShowDot="true"
        :autoplay="false"
        v-on:onBannerSliderChange="onBannerSliderChange"/>

        <NotPartner v-if="!isPartner"/>

        <div v-else>
            <SearchBar class="partner-cruiseSearch"
            :cruiseFilters='pageData.cruiseFilters'
            :isShowHp="true"
            :rowCruiseSearchHandler="rowCruiseSearchHandler"
            />

            <div class="partner-cruise-switch">
                <div class="partner-cruise-switch-container">
                    <div class="partner-cruise-item partner-cruise-hp" :class="{ active: mode == 'hp'}" @click="onModeChange('hp')">
                        <img src="https://resource.rcclchina.com.cn/partner/switch-hp.jpg">
                        <div class="img-cover"></div>
                        <div class="partner-cruise-title">中国出发航线</div>
                        <div class="partner-cruise-arrow">
                            <img src="https://resource.rcclchina.com.cn/partner/cruise-switch-arrow.png">
                        </div>
                    </div>
                    <div class="partner-cruise-item partner-cruise-row" :class="{ active: mode == 'row'}" @click="onModeChange('row')">
                        <img src="https://resource.rcclchina.com.cn/partner/switch-row.jpg">
                        <div class="img-cover"></div>
                        <div class="partner-cruise-title">海外出发航线</div>
                        <div class="partner-cruise-arrow">
                            <img src="https://resource.rcclchina.com.cn/partner/cruise-switch-arrow.png">
                        </div>
                    </div>
                </div>
            </div>

            <PartnerCruise 
            :isRow="mode=='row'"
            :cruises="cruises"
            :hotCruises="hotCruises"
            :showLoginPopup="showLoginPopup"
            :rowCruiseSearchHandler="rowCruiseSearchHandler"/>

            <div class="partner-rule">
                <div class="container">
                    <p class="partner-title">活动规则</p>
                    <div class="partner-rule-content">
                        <p>1. 在皇家官方渠道（即皇家官网及海外航线销售合作伙伴“中旅途易旅游有限公司北京绿洲旅游分公司”网站）普通散客不含税船票价格基础上再享：（1）9折优惠；或（2）深度特惠（仅适用于部分指定航次及房型，一般比9折更优惠），上述两项不可同享。</p>
                        <p>2. 适用航次及房型：</p>
                        <p>1）2024~2025年“皇家加勒比国际游轮”部分在售中国母港出发的海洋光谱号航次（不包含的航次为：2024年5月1日，2024年10月1日，2025年1月28日，2025年2月1日）。优惠活动仅适用于海洋光谱号的阳台房、海景房、内舱房。</p>
                        <p>2）2024~2025年“皇家加勒比国际游轮”部分海外港口出发的航次的阳台房、海景房、内舱房。</p>
                        <!-- <p>3）2021年“皇家加勒比国际游轮”海外港口出发的航次。</p> -->
                        <p>3. 上述福利仅限加入皇家“优先合作伙伴计划”的公司的员工及直系亲属，通过皇家合作伙伴网页或官方预订电话（需进行身份验证）生成的新预订，不适用于既往预订或通过旅行社等其他渠道的预订。</p>
                        <p>4. 上述福利不适用于预订随机房型，即舱房号随机分配的房型。</p>
                        <p>5. 每个注册账号在同一航次同一账户最多可预订3~7间房不等，视航次售卖情况而开放，超出部分不享受本福利。</p>
                        <p>6. 本福利不可与皇家会员折扣、船上未来假期折扣、各类船上消费抵用金（OBC）、各类膨胀订金、通兑券以及其他特殊渠道（如：指定银行卡活动）或特定闪惠活动等同享，亦不适用于港务税费、游轮服务费和其他费用等。</p>
                        <p>7. 除本条款另有说明外，预订相关政策（包括不限于预订变更、取消等政策）与皇家官方渠道普通散客预订相同。</p>
                        <p>8. 皇家加勒比国际游轮保留变更或终止本优先合作伙伴计划的权利，以及法律允许范围内对本条款的解释权。</p>
                    </div>
                </div>
            </div>

            <AllowTuiPopup 
                :isShow="isShowAllowTuiPopup"
                :onAllowTuiClick="onAllowTuiClick"
                v-on:onModalClose="isShowAllowTuiPopup=false"
            />

        </div>
        <LoginModal
        v-if="isShowLoginPopup"
        :onLoginSuccessHandler="onLoginSuccessHandler"
        :isShow="isShowLoginPopup"/>
    </div>
</template>

<script>
import api from '@/api'
const BannerKV = () => import('@/components/BannerKV')
const SearchBar = () => import('@/components/SearchBar/SearchBar')
const NotPartner = () => import('@/components/Partner/NotPartner')
const PartnerCruise = () => import('@/components/Partner/PartnerCruise')
const AllowTuiPopup = () => import('@/components/Common/AllowTuiPopup')
const LoginModal = () => import('@/components/User/LoginModal.vue')
export default {
    name: "PartnerIndex",
    components: {
        BannerKV,
        NotPartner,
        SearchBar,
        AllowTuiPopup,
        PartnerCruise,
        LoginModal
    },
    data () {
        return {
            pageData: {},
            isFirstLoading: true,
            isShowAllowTuiPopup: false,
            rowUrl:"",
            mode: "hp",
            isShowLoginPopup: false,
            loginCallback: null,
            allowTuiData:{}
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage () {
            const request = {
                userToken: this.userToken,
                pppKey: this.pppKey
            }
            const { data } = await api.partner.indexPage(request)
            this.isFirstLoading = false
            if (data) {
                if (data.partner) {
                    this.pageData = data.partner
                }
                if (data.pppKey && data.pppKey.length > 0) {
                    this.$store.commit('SET_PPP_KEY', data.pppKey)
                }
            }
            const res = await api.partner.isAllowTuiByToken(this.userToken)
            let cruiseUrl = process.env.VUE_APP_TUI_URL + "/Cruise/Search";
            if (!res.data) {
                this.rowUrl = cruiseUrl
                this.isShowAllowTuiPopup = true
                return
            }
        },
        onBannerSliderChange (index) {
            this.mode = index == 0 ? 'hp': 'row'
        },
        async rowCruiseSearchHandler (url) {
            // const { data } = await api.partner.isAllowTuiByToken(this.userToken)
            // if (!data) {
            //     this.rowUrl = url
            //     this.isShowAllowTuiPopup = true
            //     return
            // }
            this.goTui(url)
        },
        async onAllowTuiClick (isAllow) {
            let rowUrl = this.rowUrl + ""
            if (!rowUrl || rowUrl.length == 0) {
                rowUrl = process.env.VUE_APP_TUI_URL + "/Cruise/Search"
            }
            if (!isAllow) {
                this.goTui(rowUrl)
            } else {
                await api.partner.allowTui()
                this.goTui(rowUrl)
            }
        },
        async goTui (rowUrl) {
            const { data } = await api.partner.goTui({
                userName: this.userToken,
                url: rowUrl
            })
            if (data) {
                location.href = data
            } else {
                location.href = rowUrl
            }
        },
        onModeChange (mode) {
            this.mode = mode
            // todo slide banner
        },
        showLoginPopup (callback) {
            this.isShowLoginPopup = true
            this.loginCallback = callback
        },
        onLoginSuccessHandler () {
            this.isShowLoginPopup = false
            if (this.loginCallback) {
                this.loginCallback()
                this.loginCallback = null
            }
        }
    },
    computed: {
        userToken () {
            return this.$store.state.user.userToken || ""
        },
        userMobile () {
            const userInfo = this.$store.state.user.userInfo || {}
            return userInfo.mobile || ""
        },
        pppKey () {
            return this.$store.state.user.pppKey || ""
        },
        bannerImages () {
            return [{
                image: "https://resource.rcclchina.com.cn/partner/not_login-banner-1.jpg",
            }, {
                image: "https://resource.rcclchina.com.cn/partner/not_login-banner-2.jpg"
            }]
        },
        isPartner () {
            return this.pageData.isPartner || false
        },
        isAllowTui () {
            return this.pageData.isAllowTui || false
        },
        cruises () {
            if (!this.pageData || !this.pageData.cruiseViewModels) {
                return []
            }
            if (this.mode == 'hp') {
                return this.pageData.cruiseViewModels.filter(r=>r.isRow == false)
            } else {
                return this.pageData.cruiseViewModels.filter(r=>r.isRow)
            }
        },
        hotCruises () {
            if (!this.pageData || !this.pageData.hotCruiseViewModels) {
                return []
            }
            if (this.mode == 'hp') {
                return this.pageData.hotCruiseViewModels.filter(r=>r.isRow == false)
            } else {
                return this.pageData.hotCruiseViewModels.filter(r=>r.isRow)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.index {
    position: relative;
    min-width: 1200px;
    top: -72px;

    .partner-rule {
        margin-top: 92px;
        padding-bottom: 100px;
        .container {
            width: 1200px;
        }
        .partner-rule-content {
            color: #747d80;
            font-size: 14px;
            font-weight: 400;
            margin-top: 60px;
            p {
                margin-bottom: 0px;
                line-height: 22px;
            }
        }
    }
    
}
</style>

<style lang="less">
#PartnerIndex {
    #banner {
        .carousel-control {
            display: none;
        }
    }
    .partner-bannerDot {
        bottom: 70px;
        .bannerDot {
            display: inline-block;
            vertical-align: middle;
            background-color: white;
            width: 60px;
            height: 5px;
            cursor: pointer;
            opacity: 1;
        }
        .bannerDot:first-child {
            margin-right: 15px;
        }
        .bannerDot.active {
            width: 90px;
            background-color: #ffcd00;
        }
    }
    .partner-title {
        font-size: 50px;
        color: #121920;
        font-weight: 600;
        letter-spacing: 4px;
        margin-bottom: 25px;
        text-align: center;
    }
    
    .partner-subTitle {
        color: #333333;
        font-size: 24px;
    }

    .partner-cruiseSearch {
        margin-top: 0px;
    }

    .partner-cruise-switch {
        margin-top: 50px;
        position: relative;
        width: 100%;
        .partner-cruise-switch-container {
            position: relative;
            width: 1200px;
            margin: auto;
            text-align: center;
            .partner-cruise-item {
                position: relative;
                width: 450px;
                display: inline-block;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                }
                .img-cover {
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    position: absolute;
                    top: 0;
                }
                .partner-cruise-title {
                    position: absolute;
                    width: 100%;
                    top: 0px;
                    color: white;
                    font-size: 30px;
                    font-weight: 500;
                    letter-spacing: 4px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .partner-cruise-arrow {
                    position: absolute;
                    display: none;
                    z-index: 2;
                    width: 100%;
                    bottom: -20px;
                    img {
                        width: 41px;
                        height: 41px;
                    }
                }
            }
            .partner-cruise-item.partner-cruise-hp {
                margin-right: -6px;
            }
            .partner-cruise-item.active {
                width: 533px;
                height: 170px;
                z-index: 1;
                border-bottom: solid 3px #ffcd00;
                .img-cover {
                    background-color: rgba(0, 0, 0, 0.1);
                }
                .partner-cruise-arrow {
                    display: block;
                }
            }
        }
    }
}

</style>